import { CURRENT_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  getExpensesTotal: function ({query = ''}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get('expenses/total?' + query)
  },
  getExpenses: function ({limit = 30, page = 1, filter}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get(`expenses?sort[]=dateOfPayment&sort[]=-1&OfPayment&page=${page}&limit=${limit}&${filter}`)
  },
  createExpenses: function (expense) {
    expense.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.post('expenses', expense)
  },
  editExpenses: function (expense) {
    expense.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put('expenses/' + expense.id, expense)
  },
  deleteExpenses: function (expense) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.delete('expenses/' + expense)
  },
  generateExcel ({body, query = '', client}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      responseType: 'blob',
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        'client': client
      }
    })

    return instCred.post('expenses/excel?' + query, body)
  }
}



// WEBPACK FOOTER //
// ./src/api/Expenses/api.js